import React from "react";
import ProjectBlog from "../assets/my_work/project_blog.png";
import NeoNess from "../assets/my_work/project_gym_neoness.png";
import Symfurious from "../assets/my_work/project_symfurious.png";
import ProjectTodolistReact from "../assets/my_work/project_todolist_react.png";
import ProjectQuizzVuejs from "../assets/my_work/project_quizz-vuejs.png";
// import ProjectPinpon from "../assets/my_work/project_pinpon.png";
import ProjectHeroesAngular from "../assets/my_work/project_heroes_angular.png";
import PizzaMobileApp from "../assets/my_work/project_pizza-mobile-app.png"
import McqDemo from "../assets/my_work/mcq_demo.gif";
import BeWebApp from "../assets/my_work/beweb_app.png";

// Logo technos used
// import ReactLogo from "../assets/react.png";
// import Tailwind from "../assets/tailwind.png";

const Work = () => {
  return (
    <div name="work" className="w-full md:h-min-screen bg-[#0a192f] text-gray-300">
      <div className="max-w-[1200px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="p-8">
          <p className="text-4xl font-bold inline border-b-4 border-blue-600 text-gray-300">
            Work
          </p>
          <p className="py-6">Check out some of my recent work</p>
        </div>

        {/* Container grid */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">

          {/* Grid item - Mcq Inqompass*/}
          <div
            style={{ backgroundImage: `url(${McqDemo})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project Inqompass
              </span>
            </div>
          </div>
          
          {/* Grid item - BeWeb App*/}
          <div
            style={{ backgroundImage: `url(${BeWebApp})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                BeWeb App 
              </span>
              <div className="pt-8 text-center">
                <a href="https://bitbucket.org/beweb-app/beweb-ionic-angular/src/main/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          
          {/* Grid item */}
          <div
            style={{ backgroundImage: `url(${PizzaMobileApp})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Pizza mobile App
              </span>
              <div className="pt-8 text-center">
                <a href="https://pizza-bassaoud.netlify.app/home">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/IBassaoud/pizza-mobile-app-Ionic">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          {/* Grid item */}
          <div
            style={{ backgroundImage: `url(${ProjectHeroesAngular})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project Tour of Heroes
              </span>
              <div className="pt-8 text-center">
                <a href="https://heroes-bassaoud.netlify.app/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/IBassaoud/Heroes-app-Angular">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* Grid item */}
          <div
            style={{ backgroundImage: `url(${ProjectTodolistReact})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project To-do list
              </span>
              <div className="pt-8 text-center">
                <a href="https://todolist-bassaoud.netlify.app/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/IBassaoud/app_todolist_react">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* Grid item */}
          <div
            style={{ backgroundImage: `url(${ProjectQuizzVuejs})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project Quizz app
              </span>
              <div className="pt-8 text-center">
                <a href="https://bassaoud-app-quizz-vuejs.netlify.app/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/IBassaoud/app_quizz_vuejs">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* Grid item - Project blog*/}
          <div
            style={{ backgroundImage: `url(${ProjectBlog})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project Blog application
              </span>
              <div className="pt-8 text-center">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Demo
                  </button>
                </a> */}
                <a href="https://github.com/IBassaoud/Blog-POO-PHP">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* Grid item - Project Neoness*/}
          <div
            style={{ backgroundImage: `url(${NeoNess})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project NeoNess
              </span>
              <div className="pt-8 text-center">
                <a href="https://github.com/IBassaoud/CodeIgniter4-Project_Neoness">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* Grid item */}
          <div
            style={{ backgroundImage: `url(${Symfurious})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 text-center">
              <span className="text-1xl font-bold text-white tracking-wider">
                Project Symfurious
              </span>
              <div className="pt-8 text-center">
                <a href="https://github.com/IBassaoud/Symfony-project_symfurious">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
